module.exports = __webpack_public_path__ + "img/about-introduce-right.d2db7eee.png";